/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { WebImportRequestMode } from './webImportRequestMode';

export interface WebImportRequest {
  /**
     * @minLength 1
     * @maxLength 2083
     */
  url: string;
  mode?: WebImportRequestMode;
}
